import { Box } from '@mui/material';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import useUserSettings from '@/hooks/use-user-settings.hook';
import Tab from '../tab';
import { getBreakpoint } from '@/theme';
import ResizeScrollbars from '@/components/resize-scrollbars';
import useThemeMediaQuery from '@/hooks/use-theme-media-query';
import TabHeader from '../tab/tab-header';
import TabContent from '../tab/tab-content';
import AgentCard from './agent-card';
import DatasourceCard from './datasource-card';
import PrivateModelCard from './private-model-card';
import PublicDatasourceCard from './public-datasource-card';

interface Props {
  onClose?: () => void;
}

const useStyles = createUseStyles({
  settingsCard: {
    '& .MuiFormControl-root': {
      margin: '4px 0px 0px 0px',
    },
    marginTop: 16,
  },
  [getBreakpoint('md')]: {
    settingsCard: {
      marginTop: 8,
    },
    publicSearchCard: {
      marginTop: 8,
    },
  },
});

const UserSettingsTab: FC<Props> = ({ onClose }) => {
  const { publicSearchAvailable } = useUserSettings();

  const { medium } = useThemeMediaQuery();
  const listMax = medium ? 4 : 6;

  const styles = useStyles();

  return (
    <Tab onClose={onClose}>
      <TabHeader
        icon="settings"
        title="New Chat Settings"
        description="The following settings are applied to all new conversations."
      />
      <Box flexGrow={1}>
        <ResizeScrollbars>
          <Box>
            <TabContent className={styles.settingsCard}>
              <DatasourceCard max={listMax} />
            </TabContent>

            {publicSearchAvailable && (
              <TabContent className={styles.settingsCard}>
                <PublicDatasourceCard />
              </TabContent>
            )}

            <TabContent className={styles.settingsCard}>
              <AgentCard max={listMax} />
            </TabContent>

            <Box mb={2}>
              <TabContent className={styles.settingsCard}>
                <PrivateModelCard max={listMax} />
              </TabContent>
            </Box>
          </Box>
        </ResizeScrollbars>
      </Box>
    </Tab>
  );
};

export default UserSettingsTab;
